import React, { ReactNode } from 'react';
import { Box } from '../../wag-react/next-components/box';
import { ArticleSection } from '../ArticleSection';
import { ArticleSectionContent } from '../ArticleSectionContent';
import { ArticleSectionTitle } from '../ArticleSectionTitle';
import { ReworkedMarkdown } from '../Markdown/Reworked';
export type ArticleSectionContentListValue = (Record<'title' | 'content', ReactNode> & {
  id?: string;
})[];
type Props = {
  value: ArticleSectionContentListValue;
  renderVideoContent?: () => ReactNode;
  renderBannerContent?: () => ReactNode;
  renderMobileContent?: () => ReactNode;
};
const hasContent = (article: ArticleSectionContentListValue[0]) => !!article.content;
export const ArticleSectionContentList = ({
  value,
  renderVideoContent,
  renderBannerContent,
  renderMobileContent
}: Props) => <>
    {value.filter(hasContent).map((article, index) => <ArticleSection key={article.title.toString()} id={article.id} mt={0} pt="50px">
            <ArticleSectionTitle mt={0}>
              {article.title}
            </ArticleSectionTitle>
            <ArticleSectionContent>
              <ReworkedMarkdown version="react-markdown">
                {article.content as string}
              </ReworkedMarkdown>
              {index === 0 && renderVideoContent()}
            </ArticleSectionContent>
            {index === 4 && renderBannerContent()}

            {/* Mobile/Tablet only */}
            {index === 0 && <Box display={['flex', 'flex', 'none']} flexDirection="column" mt="48px" style={{
      gap: '24px'
    }}>
                {renderMobileContent()}
              </Box>}
          </ArticleSection>)}
  </>;
export type ArticleSectionContentListProps = Props;